import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, Form, Button } from 'react-bootstrap';
import Check from '../assets/check.svg';


const formatURL = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url
}
export default (props) =>{
  return(
    <div style={{textAlign:'center',height:'calc(100vh - 260px)', paddingTop:'calc(50vh - 360px)'}}>
      <div>
        <Image src={Check} style={{marginBottom:30, height: 200}}/>
      </div>
      <div style={{fontSize:20, fontWeight:'bold'}}>
        {props.translations.checkout.waiting.thanks}
        <p>{props.translations.checkout.waiting.order_in_process_01} <span style={{color:'#1F45FF'}}>#{props.reference}</span> {props.translations.checkout.waiting.order_in_process_02}</p>
        <Button className='ecomm-button' onClick={()=>window.location.replace(formatURL(props.url))}>{props.translations.checkout.waiting.return}</Button>
      </div>
    </div>
  )
}
